import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emphasistab-radiobtn" }
const _hoisted_2 = { class: "radio-btn" }
const _hoisted_3 = { class: "applybtn-tooltip" }

import { ref, computed, watchEffect } from 'vue'
import RadioButton from '@/components/UI/RadioButton.vue'
import Button from '@/components/UI/Button.vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { VoicesMutationTypes as VoicesMutationType } from '@/store/voices/mutations'
import { addTagsToSelection } from '@/utils/addTagsToSelection'
import { useRoute } from 'vue-router'
import CustomTooltip from '@/components/UI/CustomToolTip.vue'

const tagClass = 'emphasis'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmphasisTab',
  props: {
  userId: {
    type: String
  },
  disableApplyPlay: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props
const emphasisValue = ref('')
const { t } = useI18n()
const route = useRoute()
const routeQuery = route.query
const store = useStore()
// const disableApplyButton = ref(true)
const emphasisStore = computed(() => store.state.voices.voiceEmphasisValue)
const defaultEmphasis = ref(t('_radioButtons.moderate'))
const emphasisApiValue = ref('moderate')
const selection = document.getSelection()
const emphasisChange = (e) => {
  emphasisValue.value = t('_radioButtons.' + e.target.value)
  emphasisApiValue.value = e.target.value
}
const showTooltip = ref(false)

const disableApplyButton = computed(() => {
  let value = true
  const conditions = addTagsToSelection(
    selection,
    emphasisValue.value,
    t('_radioButtons.normal'),
    emphasisApiValue.value,
    tagClass,
    t,
    ''
  )

  if (props.disableApplyPlay == false && emphasisValue.value !== 'Normal') {
    value = false
  }

  if (conditions == false) {
    value = false
  }
  return value
})

const applyEffects = () => {
  if (selection.isCollapsed == true && emphasisValue.value != '') {
    store.commit(VoicesMutationType.SET_VOICE_EMPHASIS_VALUE, emphasisValue.value)
    defaultEmphasis.value = emphasisValue.value
  }
  addTagsToSelection(
    selection,
    emphasisValue.value,
    t('_radioButtons.normal'),
    emphasisApiValue.value,
    tagClass,
    t,
    'CRUD'
  )
}

watchEffect(() => {
  emphasisStore.value
  if (emphasisStore.value == '') {
    defaultEmphasis.value = t('_radioButtons.moderate')
    emphasisValue.value = t('_radioButtons.moderate')
    emphasisApiValue.value = 'moderate'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioButton, {
        label: _ctx.$t('_radioButtons.reduced'),
        values: "reduced",
        checked: defaultEmphasis.value == _ctx.$t('_radioButtons.reduced') ? true : false,
        onChange: emphasisChange,
        name: "emphasis"
      }, null, 8, ["label", "checked"]),
      _createVNode(RadioButton, {
        label: _ctx.$t('_radioButtons.normal'),
        values: "normal",
        checked: defaultEmphasis.value == _ctx.$t('_radioButtons.normal') ? true : false,
        onChange: emphasisChange,
        name: "emphasis"
      }, null, 8, ["label", "checked"]),
      _createVNode(RadioButton, {
        label: _ctx.$t('_radioButtons.moderate'),
        values: "moderate",
        checked: defaultEmphasis.value == _ctx.$t('_radioButtons.moderate') ? true : false,
        onChange: emphasisChange,
        name: "emphasis"
      }, null, 8, ["label", "checked"]),
      _createVNode(RadioButton, {
        label: _ctx.$t('_radioButtons.strong'),
        values: "strong",
        checked: defaultEmphasis.value == _ctx.$t('_radioButtons.strong') ? true : false,
        onChange: emphasisChange,
        name: "emphasis"
      }, null, 8, ["label", "checked"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "applybutton",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = false))
      }, [
        _createVNode(Button, {
          text: _ctx.$t('_buttons.apply'),
          buttonType: "emphasis-tab-apply",
          isDisabled: disableApplyButton.value,
          onClick: applyEffects
        }, null, 8, ["text", "isDisabled"])
      ], 32),
      _createVNode(CustomTooltip, {
        style: _normalizeStyle({
          opacity: showTooltip.value ? 1 : 0,
          visibility: showTooltip.value ? 'visible' : 'hidden'
        }),
        toolTipText: _ctx.$t('_toolTip.effectDisabledToolTipText'),
        disableTooltip: disableApplyButton.value,
        toolTipType: "applybtn"
      }, null, 8, ["style", "toolTipText", "disableTooltip"])
    ])
  ]))
}
}

})